export function onLink() {
  document.body.addEventListener('click', (event) => {
    const target = event?.detail?.target ?? event?.target;

    /**
     * click sobre el boton de enlace de un mensaje de alerta
     */
    if (target?.getAttribute('action') === 'link') {
      const url = target?.getAttribute('url');
      globalThis.location = url;
    }
  });
}
